import type { Notification } from './notification';
import type { Task } from './task';

export enum StreamCategory {
  RESOURCE = 'resource',
  NOTIFICATION = 'notification',
  TASK = 'task',
}

export enum ResourceStreamEventType {
  REPLACE = 'replace',
  DELETE = 'delete',
  INSERT = 'insert',
}

export type ResourceStreamEventData = {
  changed: unknown[];
  id: string;
  name: string;
  projectId: string;
  resourceType: string;
  serviceName: string;
  status: string;
};

export interface ResourceStreamEvent {
  category: StreamCategory.RESOURCE;
  eventType: ResourceStreamEventType;
  payload: ResourceStreamEventData;
}

export interface NotificationStreamEvent {
  category: StreamCategory.NOTIFICATION;
  payload: Notification;
}

/**
 * SSE TASK 이벤트 payload는 Task 전체 객체로 내려온다 (status, progressPercent, steps 등 포함).
 */
export interface TaskStreamEvent {
  category: StreamCategory.TASK;
  payload: Task;
}

export type StreamEventPayload = NotificationStreamEvent | ResourceStreamEvent | TaskStreamEvent;
